import {
  Create,
  TabbedForm,
  FormTab,
  TextInput,
  ArrayInput,
  SimpleFormIterator,
  email,
  NumberInput,
} from 'react-admin';
import { MediaInput } from '../../components/inputs/MediaInput';

export const VacancyPageDataCreate = () => {
  return (
    <Create>
      <TabbedForm>
        <FormTab label="Основная информация">
          <TextInput
            source="email"
            label="Контактный email"
            validate={[email()]}
            helperText="Email для связи по вакансиям"
            fullWidth
          />
          <TextInput
            source="location"
            label="Локация"
            helperText="Местоположение компании"
            fullWidth
          />
          
          <ArrayInput source="benefits" label="Преимущества">
            <SimpleFormIterator>
              <TextInput
                source=""
                label="Преимущество"
                helperText="Описание преимущества работы в компании"
                fullWidth
              />
            </SimpleFormIterator>
          </ArrayInput>
        </FormTab>

        <FormTab label="Изображения страницы">
          <ArrayInput source="images" label="Изображения страницы">
            <SimpleFormIterator>
              <TextInput
                source="title"
                label="Заголовок"
                helperText="Заголовок изображения"
                fullWidth
              />
              <TextInput
                source="description"
                label="Описание"
                helperText="Описание изображения"
                multiline
                rows={2}
                fullWidth
              />
              <MediaInput
                source="mediaId"
                label="Изображение"
                helperText="Выберите изображение"
                accept="image/*"
                showPreview={true}
              />
              <NumberInput
                source="sortOrder"
                label="Порядок сортировки"
                helperText="Порядок отображения (необязательно)"
              />
            </SimpleFormIterator>
          </ArrayInput>
        </FormTab>

        <FormTab label="Изображения слайдера">
          <ArrayInput source="sliderImages" label="Изображения слайдера">
            <SimpleFormIterator>
              <TextInput
                source="title"
                label="Заголовок"
                helperText="Заголовок изображения слайдера"
                fullWidth
              />
              <TextInput
                source="description"
                label="Описание"
                helperText="Описание изображения слайдера"
                multiline
                rows={2}
                fullWidth
              />
              <MediaInput
                source="mediaId"
                label="Изображение слайдера"
                helperText="Выберите изображение для слайдера"
                accept="image/*"
                showPreview={true}
              />
              <NumberInput
                source="sortOrder"
                label="Порядок сортировки"
                helperText="Порядок отображения (необязательно)"
              />
            </SimpleFormIterator>
          </ArrayInput>
        </FormTab>
      </TabbedForm>
    </Create>
  );
};
